import {makeStyles, createStyles} from '@material-ui/core/styles'

const drawerWidth = 240

const useStyles = makeStyles(theme =>
    createStyles({
        appMenu: {
            width: '100%',
        },

        navList: {
            width: drawerWidth,
        },

        menuItem: {
            width: drawerWidth,
            "&:hover $menuItemIcon": {
                color: '#1A5487',
                backgroundColor: "rgba(255,255,255,0.1)"
            },
            "&:hover $openSubMenuIcons":{
                color: '#01A0EC'
            },
            "&:hover $menuItemText":{
                color: '#01A0EC'
            }
        },

        menuItemIcon: {
            color: '#333',
        },

        menuItemText: {
            color: '#333',
            '& span, & svg': {
                fontSize: '14px'
            },
            "&:hover": {
                color: '#01A0EC'
            },
        },

        nested: {
            paddingLeft: theme.spacing(4),
            width: drawerWidth,
            "&:hover $fiberManualRecordIcon": {
                backgroundColor: "rgba(255,255,255,0.1)",
                color: '#43729C'
            },
        },

        subItemsText: {
            '& span, & svg': {
                fontSize: '12px'
            },
            color: '#222',
            "&:hover": {
                color: '#01A0EC'
            },
        },

        divider: {
            background: '#E0E0E0',
        },

        fiberManualRecordIcon: {
            fontSize: 10,
            color: "#333",
            marginRight: 10
        },

        openSubMenuIcons :{
            color: "#333"
        }

    }),
)

export {useStyles}
